export default {

	notifications: {
		timeout: 2000,
	},

	widget: {
		defaultCloud: "hzxyensd5",
		defaultDevCloud: "yoav",
		defaultPreset: "aoh4fpwm",
		defaultDevPreset : "uw_usigned",
		googleApiKey: "AIzaSyAugh8ddeFTt5ckj9rFcRKNHxem18hKiRo",
		stagingUploadPrefix: "https://api-staging.cloudinary.com/",
		folder: "uw2-public-demo-app",
	}
};
